import { API_URL } from "../config";
import { setCarrito, setLoading, setError } from "../store/slices/carrito-slice";


const buildQueryParams = (params) => {
  const searchParams = new URLSearchParams();
  
  Object.keys(params).forEach(key => {
    if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
      searchParams.append(key, params[key]);
    }
  });
  
  return searchParams.toString();
};


// Obtener carrito
export const fetchCarrito = (sessionId, usuarioRef = null, carritoRef = null) => async (dispatch) => {
  dispatch(setLoading(true));
  
  const params = buildQueryParams({
    sessionId,
    usuarioRef,
    carritoRef
  });
  
  const url = `${API_URL}/api/v2/Carrito${params?`?${params}`:''}`;
  console.log(url);
  
  try {
    const response = await fetch(url, {
      method: "POST",
      credentials: "include",
      headers: {
        "Accept": "application/json"
      }
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const data = await response.json();
    dispatch(setCarrito(data));
    console.log(data.message);
    return data;

  } catch (error) {
    console.error(error);
    dispatch(setError(error.message));
    return null;
  }
};

// Agregar item al carrito
export const addItemToCarrito = (carritoRef, codigoInterno, cantidad) => async (dispatch, getState) => {
  dispatch(setLoading(true));
  
  const url = `${API_URL}/api/v2/Carrito?carritoRef=${encodeURIComponent(carritoRef)}&codigoInterno=${encodeURIComponent(codigoInterno)}&cantidad=${encodeURIComponent(cantidad)}`;
  
  try {
    const response = await fetch(url, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Accept": "application/json"
      }
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const data = await response.json();
    console.log(data.message); // "Se agregó 10.00 de Baseus PB"
    
    // Recargar el carrito completo desde el servidor
    const { session } = getState().session;
    dispatch(fetchCarrito(session?.sessionId, session?.usuarioRef, carritoRef));
    return data;

  } catch (error) {
    console.error(error);
    dispatch(setError(error.message));
    throw error;
  }
};

// Eliminar item del carrito
export const removeItemFromCarrito = (carritoRef, codigoInterno) => async (dispatch) => {
  dispatch(setLoading(true));
  
  const url = `${API_URL}/api/v2/Carrito/${carritoRef}/item/${codigoInterno}`;
  
  try {
    const response = await fetch(url, {
      method: "DELETE",
      credentials: "include",
      headers: {
        "Accept": "application/json"
      }
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const data = await response.json();
    console.log(data.message);
    
    // Recargar el carrito completo
    dispatch(fetchCarrito(carritoRef));

  } catch (error) {
    console.error(error);
    dispatch(setError(error.message));
  }
};

// Actualizar cantidad de un item
export const updateItemQuantity = (carritoRef, codigoInterno, cantidad) => async (dispatch) => {
  dispatch(setLoading(true));
  
  const url = `${API_URL}/api/v2/Carrito/${carritoRef}/item/${codigoInterno}`;
  
  try {
    const response = await fetch(url, {
      method: "PUT",
      credentials: "include",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ cantidad })
    });

    if (!response.ok) {
      throw new Error(`Error: ${response.status}`);
    }

    const data = await response.json();
    console.log(data.message);
    
    // Recargar el carrito completo
    dispatch(fetchCarrito(carritoRef));

  } catch (error) {
    console.error(error);
    dispatch(setError(error.message));
  }
};
